import * as React from 'react';
import { GlobalStyles } from '@mui/material';

type Props = React.PropsWithChildren<{}>;

export const OverridenGlobalStyles: React.FC<Props> = ({ children }) => (
    <>
      <GlobalStyles
      styles={{
        '.MuiDialog-root [class*="MUIDataTableFilter"] .MuiDialog-container .MuiPaper-root.MuiDialog-paper': {
          maxWidth: 540,
          width: '60vw',
          margin: '16px',
        },

        '.MuiDialog-root [class*="MUIDataTableFilter"] .MuiGrid-container': {
          columnGap: '24px',
        },
        '.MuiDialog-root [class*="MUIDataTableFilter"] .MuiGrid-item': {
          maxWidth: '10% !important',
          flexBasis: '10% !important',
        },
        '.MuiDialog-root [class*="MUIDataTableFilter"] .MuiFormControl-root': {
          width: '70% !important',
        },

        '.MuiDialog-root [class*="MUIDataTableFilter"] .MuiInputBase-root': {
          fontSize: '0.9rem',
        },
        '.MuiDialog-root [class*="MUIDataTableFilter"] .MuiInputLabel-root, .MuiDialog-root [class*="MUIDataTableFilter"] .MuiFormHelperText-root': {
          fontSize: '0.9rem',
        },

        '@media (max-width: 600px)': {
          '.MuiDialog-root [class*="MUIDataTableFilter"] .MuiGrid-item': {
            maxWidth: '70% !important',
            flexBasis: '70% !important',
          },
        },
      }}
    />
       {children}
    </>
);
